import * as React from 'react';
import * as propTypes from 'prop-types';
import styled from '@emotion/styled';
import { ArrowDownIcon } from '../Icons/ArrowDownIcon';

export interface IOptions {
    id: number;
    label: string;
}
export interface ISelectButtonProps {
    onSelectClick: any;
    options: Array<IOptions>;
    selectedFacet: any;
}
const OverviewSelect = styled.div`
    display: inline-flex;
    flex-wrap: wrap;
    flex-direction: row;
    flex: 1 0 30%;
    position: relative;
`;
const StyledArrowDownIcon = styled(ArrowDownIcon)`
    position: absolute;
    right: 8px;
    top: 0;
    bottom: 0;
    margin: auto 0;
    height: 12px;
    width: 12px;
    fill: ${({ theme }) => theme.colors.darkCharcoal[100]};
`;

const StyledSelect = styled.select`
    background: ${({ theme }) => theme.colors.white[100]};
    border: none;
    border-radius: 6px;
    width: 100%;
    cursor: pointer;
    padding: 10px 20px 10px 8px;
    font-size: 14px;
`;

export default class SelectButton extends React.Component<ISelectButtonProps, {}> {
    static contextTypes = {
        track: propTypes.func,
    };

    constructor(props) {
        super(props);
        this.handleClick = this.handleClick.bind(this);
    }

    handleClick(event) {
        const value = parseInt(event.target.value, 10);
        const option = this.props.options.find((item) => value === item.id);
        const context = this.context as any;
        if (option) {
            this.props.onSelectClick(option);
        }
        if (context.track) {
            context.track({ actionValue: option.label });
        }
    }

    preventPropagation(event) {
        event.stopPropagation();
    }

    getSelectedValue() {
        return this.props.selectedFacet ? this.props.selectedFacet.id : this.props.options[0].id;
    }

    render() {
        return (
            <OverviewSelect>
                <StyledArrowDownIcon />
                <StyledSelect
                    onChange={this.handleClick}
                    onClick={this.preventPropagation}
                    value={this.getSelectedValue()}
                >
                    {this.props.options.map((option) => (
                        <option key={option.id} value={option.id}>
                            {option.label}
                        </option>
                    ))}
                </StyledSelect>
            </OverviewSelect>
        );
    }
}
